import { Icon, Text } from 'components';
import { theme } from 'lib';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const Wrapper = styled.div`
  margin-top: 82px;

  .led-by-fans {
    width: 70%;
  }

  @media (max-width: 1024px) {
    margin: 108px 0 0px;

    .led-by-fans {
      width: 80%;
    }
  }
`;

const RedBg = styled.div`
  width: 100%;
  height: 338px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${theme.SECONDARY};
  margin: 70px 0 130px;

  @media (max-width: 1024px) {
    height: 308px;
    position: relative;
    margin: 74px 0 266px;
  }
`;

const Container = styled.div`
  display: flex;
  align-self: center;
  justify-content: space-between;
  width: 1140px;
  height: 550px;

  @media (max-width: 1024px) {
    width: 100vw;
    overflow-x: scroll;
    overflow-y: hidden;
    position: absolute;
    top: -30px;
  }
`;

const ContentContainer = styled.div`
  width: 550px;
  position: relative;
  cursor: pointer;

  @media (max-width: 1024px) {
    width: unset;
    margin-right: 0px;
    padding: 0 15px;
  }
`;

const ContentBg = styled.div`
  ${(props) =>
    props.fanZone
      ? `background-image: url(${require('assets/images/fans-background-resized.png')});`
      : 'background: #000;'}
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  width: 440px;
  height: 330px;
  z-index: 3;
  margin-top: 142px;

  h3 {
    z-index: 1;
    top: 247px;
    position: absolute;
    font-size: 96px;
    line-height: 72px;
    letter-spacing: -5px;
    margin-left: -3px;
  }

  @media (max-width: 1024px) {
    display: none;
  }
`;

const ImageBackground = styled.div`
  background: url(${(props) => props.img});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 330px;
  width: 330px;

  position: absolute;
  top: 81px;
  right: 0;

  @media (min-width: 1024px) {
    h3 {
      display: none;
    }
  }

  @media (max-width: 1024px) {
    position: unset;
    height: 312px;
    width: 312px;
    display: flex;
    margin-bottom: 40px;
    display: flex;
    align-items: flex-end;

    h3  {
      font-size: 72px;
      line-height: 60px;
      letter-spacing: -2.5px;
      margin-left: -5px;
    }
  }
`;

const TextContainer = styled.div`
  margin-top: 18px;
  position: relative;

  .fan-arrow {
    right: 130px !important;
  }

  h4  {
    font-size: 30px;
    color: ${theme.SECONDARY};
    letter-spacing: -0.5px;
    font-weight: 500;
  }

  p {
    margin-top: 10px;
    font-size: 24px;
    letter-spacing: 0;
    width: 74%;
  }

  @media (max-width: 1024px) {
    margin-top: 64px;

    p {
      width: unset;
    }
  }
`;

const ArrowContainer = styled.div`
  position: absolute;
  right: 180px;
  bottom: -7px;

  @media (max-width: 1024px) {
    position: unset;
    margin-top: 5px;
  }
`;

const AthAndFanZone = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return null;

  return (
    <Wrapper>
      <RedBg>
        <Container>
          <ContentContainer onClick={() => navigate('/athlete-zone')}>
            <ContentBg>
              <Text h3 col="#fff" stencil>
                {t('website.ledByAthletes')}
              </Text>
            </ContentBg>

            <ImageBackground img={null}>
              <Text h3 col="#fff" stencil>
                {t('website.ledByAthletes')}
              </Text>
            </ImageBackground>

            <TextContainer>
              <Text h4>{t('website.amAnAthlete')}</Text>

              <Text>{t('website.monetizeYourBrand')}</Text>

              <ArrowContainer>
                <Icon type="arrowRightLonger" col={theme.SECONDARY} dimensions={42} />
              </ArrowContainer>
            </TextContainer>
          </ContentContainer>

          <ContentContainer onClick={() => navigate('/fan-zone')}>
            <ContentBg fanZone>
              <Text h3 col="#fff" stencil className="led-by-fans">
                {t('website.ledByFans')}
              </Text>
            </ContentBg>

            <ImageBackground img={require('assets/images/homepage-fan-lady.png')}>
              <Text h3 col="#fff" stencil className="led-by-fans">
                LED BY FANS.
              </Text>
            </ImageBackground>

            <TextContainer>
              <Text h4>{t('website.amAFan')}</Text>

              <Text>{t('website.connectDirectlyWith')}</Text>

              <ArrowContainer className="fan-arrow">
                <Icon type="arrowRightLonger" col={theme.SECONDARY} dimensions={42} />
              </ArrowContainer>
            </TextContainer>
          </ContentContainer>
        </Container>
      </RedBg>
    </Wrapper>
  );
};

export default AthAndFanZone;
